__turbopack_context__.v({
  "detailHeaderContainer": "DetailSkeleton-module__59tKhG__detailHeaderContainer",
  "detailHeaderMetadata": "DetailSkeleton-module__59tKhG__detailHeaderMetadata",
  "detailHeaderMetadataItem": "DetailSkeleton-module__59tKhG__detailHeaderMetadataItem",
  "detailPreviewContainer": "DetailSkeleton-module__59tKhG__detailPreviewContainer",
  "detailPreviewFrame": "DetailSkeleton-module__59tKhG__detailPreviewFrame",
  "detailRowsContainer": "DetailSkeleton-module__59tKhG__detailRowsContainer",
  "detailSkeletonContainer": "DetailSkeleton-module__59tKhG__detailSkeletonContainer",
});
